module.exports = __webpack_public_path__ + "fonts/icomoon.eb291d6.ttf";